<ion-card>
  <ion-card-header *ngIf="showHeader">
    <div class="flex-container grid-block sticky-header">
      <div class="left-column dash-cont-title">
        {{ gridConfigItems.title }}
      </div>
      <div class="right-column" >
        <app-searchbar #gridSearchbar class="custom-searchbar" [(ngModel)]="searchText" [value]="searchText" [showSearchBar]="false" [disabled]="searchDisabled" placeholder="{{ gridConfigItems.placeholder }}"
             ngDefaultControl (ionChange)="onGridSearchTextChange($event)" (clear)="clearSearchedInput()">
        </app-searchbar>
        <ng-content select="[gridHeaderExtras]"></ng-content>
          <ion-button class="right-margin-12 btn-border" shape="round" fill="outline" 
            [hidden]="!gridConfigItems.isWritePermission" [disabled]="gridConfigItems.isButtonDisabled" (click)="onButtonClick()">
              <ion-icon slot=start name='add-circle-outline' >
              </ion-icon>
              {{ gridConfigItems.buttonTitle }}
        </ion-button>
        <img #gridMoreIcon tooltip="{{'More actions' | translate }}" alt="" [hidden]="!showKebabIcon" placement="top" class="ellipsis-icon ellipsis-right-margin" 
        src="../../../assets/icon/more.svg" tabindex="0" role="button" [attr.aria-label]="'More actions' | translate"
        (click)="openStatusPopover($event)"
        (keydown.enter)="openStatusPopover($event)"
        (keydown.space)="$event.preventDefault(); openStatusPopover($event)">
      </div>
  </div>
  </ion-card-header>
  <!-- Shimmer card-content on ag-grid-->
  <ion-card-content *ngIf="sharedValue?.isGridDataLoading">
    <div class="shimmer-wrapper">
      <div class="shimmer-item" *ngFor="let cell of shimmerGrid"></div>
    </div>
  </ion-card-content>
  <ion-card-content class="card-container scrollVertical" *ngIf="!sharedValue?.isGridDataLoading">
    <div class="outer-div">
      <div class="grid-wrapper {{gridConfigItems.gridWrapperHeightClass}}"
           [ngStyle]="gridstyle"
           *ngIf="gridOptions">
            <ag-grid-angular #agGrid
                  [ngStyle]="gridWrapperstyle"
              [attr.data-grid-focus-key]="gridFocusKey"
                  id="myGrid"
                  rowModelType="infinite"
                  cacheBlockSize=10
                  class="ag-theme-alpine"
                [ngClass]="{ 'custom-hover': gridConfigItems.isHoverRowColumnHighlight, 'app-grid-keyboard-focus-visible': isKeyboardFocusVisible }"
              (focusin)="onGridFocusIn($event)"
              (focusout)="onGridFocusOut($event)"
              (mousedown)="onGridPointerInteraction()"
              (touchstart)="onGridPointerInteraction()"
                  (gridReady)="onGridReady($event)"
                  (columnResized)="oncolumnResized($event)"
                  (cellClicked)="onCellClicked($event)"
                  (cellFocused)="onCellFocused($event)"
                  (cellKeyDown)="onCellKeyDown($event)"
                  (keydown)="onGridKeyDown($event)"
                  [gridOptions]="gridOptions"
                  [suppressDragLeaveHidesColumns]="true"
                  [suppressMakeColumnVisibleAfterUnGroup]="true"
                  [rowGroupPanelShow]="rowGroupPanelShow"
                  [autoGroupColumnDef]="autoGroupColumnDef"
                  [enableRangeSelection]="true"
                  [groupHideOpenParents]="true"
                  [animateRows]="true"
                  [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                  [overlayLoadingTemplate]="overlayLoadingTemplate"
                  [pinnedBottomRowData]="pinnedBottomRowData"
                  [suppressRowHoverHighlight]="gridConfigItems.suppressRowHoverHighlight"
                  [columnHoverHighlight]="false"
                  [alwaysShowHorizontalScroll]="true">
          </ag-grid-angular>
      </div>
      <div class="grid-load-more" *ngIf="isLoadingMore" role="status" aria-live="polite">
        <ion-spinner name="dots" class="grid-load-more__spinner"></ion-spinner>
        <span class="grid-load-more__text">{{ 'Loading more' | translate }}...</span>
      </div>
  </div>
  </ion-card-content>
</ion-card>
